import AzureLogo from './Azure_Logo.svg';
import CLogo from './C_Logo.svg';
import CSharpLogo from './CSharp_Logo.svg';
import CPlusPlusLogo from './C++_Logo.svg';
import JavaScriptLogo from './JavaScript_Logo.svg';
import KustoLogo from './Kusto_Logo.svg';
import NGINXLogo from './NGINX_Logo.svg';
import PythonLogo from './Python_Logo.svg';
import SQLLogo from './SQL_Logo.svg';
import UnityLogo from './Unity_Logo.svg';
import UnrealLogo from './Unreal5_Logo.svg';
import WindowsLogo from './Window_Logo.svg';

export const logos = {
        'Azure': AzureLogo,
        'C': CLogo,
        'C#': CSharpLogo,
        'C++': CPlusPlusLogo,
        'Javascript': JavaScriptLogo,
        'Kusto': KustoLogo,
        'NGINX': NGINXLogo,
        'Python': PythonLogo,
        'SQL': SQLLogo,
        'Unity': UnityLogo,
        'Unreal5': UnrealLogo,
        'WinDBG': WindowsLogo,
        'WPA': WindowsLogo
};